export const openFloatingChat = (payload = {}) => {
    if (typeof window === "undefined") return;

    window.dispatchEvent(new CustomEvent("ao-floating-chat:open", {
        detail: payload,
    }));
};

export const closeFloatingChat = () => {
    if (typeof window === "undefined") return;

    window.dispatchEvent(new CustomEvent("ao-floating-chat:close"));
};